module.exports = {
  path: 'add',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/ProfileAdd'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/profiles/routes/add/index.js